import { Badge } from "@/components/ui/badge"

/**
 * Match-confidence badge with one app-wide threshold scheme so the colors are identical in the PSE
 * Online list and detail views (previously the list used >=70% green while the detail used >=90%, so
 * the same 70–89% match showed green in one place and yellow in the other).
 *
 * >= 70% green · >= 40% yellow · otherwise red.
 */
export function ConfidenceBadge({ confidence }: { confidence: number }) {
  const pct = Math.round(confidence * 100)
  if (confidence >= 0.7) return <Badge className="bg-green-600 text-white">{pct}%</Badge>
  if (confidence >= 0.4) return <Badge className="bg-yellow-500 text-black">{pct}%</Badge>
  return <Badge variant="destructive">{pct}%</Badge>
}
